export type SiteQuerySource = "opened-folders" | "site-details";

const TAB_ID_STORAGE_KEY = "@voltacall/observability/tab-id";

function createId(): string {
  return globalThis.crypto.randomUUID();
}

function getTabId(): string {
  const storedTabId = globalThis.sessionStorage.getItem(TAB_ID_STORAGE_KEY);
  if (storedTabId) {
    return storedTabId;
  }

  const tabId = createId();
  globalThis.sessionStorage.setItem(TAB_ID_STORAGE_KEY, tabId);
  return tabId;
}

export const voltacallRequestContext = {
  tabId: getTabId(),
  pageLoadId: createId(),
} as const;

export function getSiteRequestHeaders(querySource: SiteQuerySource): Record<string, string> {
  return {
    "Voltacall-Tab-Id": voltacallRequestContext.tabId,
    "Voltacall-Page-Load-Id": voltacallRequestContext.pageLoadId,
    "Voltacall-Query-Source": querySource,
  };
}
